const overlayCount = {
  value: 0,
  increment() {
    if (this.value === 0) {
      // Locks body scroll
      document.body.style.overflowY = 'hidden';
    }
    this.value += 1;
  },
  decrement() {
    if (this.value === 1) {
      this.value = 0;
      // Frees body scroll
      document.body.style.overflowY = 'auto';
      return;
    }

    this.value -= 1;
  },
};

export default overlayCount;
